import React, {Component} from 'react';

class Checkbox extends Component {

    constructor(props){
        super(props)
        this.state = {
            checked:props.checked || false,
        }
    }

    componentWillReceiveProps(nextProps){
        if (nextProps.checked != undefined && nextProps.checked !== this.state.checked){
            this.setState({checked:nextProps.checked});
        }

    }
    onChange = (event) => {
        const {checked} = event.target;
        this.setState({checked});
        this.props.onChange(checked, event)
    }

    render() {
      const {children, labelStyle, ...rest} = this.props
      return <div className="form-field">
        <input {...rest} type="checkbox" checked={this.state.checked} onChange={this.onChange}/>
          {children &&
            <label htmlFor={this.props.id} style={labelStyle} >
            {children}
          </label>}
      </div>;
    }
}


export default Checkbox;



// WEBPACK FOOTER //
// ./src/public/journey1/fragments/services/Checkbox.js